import { NotificationPreferencesForm } from "../../features/notifications";

// NotificationPreferencesScreen — route landing for
// /notifications/preferences. Mounts under MainLayout. Uses the same
// canonical clients-header grammar as Clients / Deals / Notification Center.

function NotificationPreferencesScreen() {
  return (
    <section
      className="clients-page feature-notification-preferences"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <section
          className="clients-overview"
          aria-label="Огляд налаштувань сповіщень"
        >
          <header className="clients-header">
            <div className="clients-header__text">
              <h1 className="clients-header__title">
                Налаштування сповіщень
              </h1>
              <p className="clients-header__sub">
                Керуйте каналами доставки та категоріями подій.
              </p>
            </div>
          </header>
        </section>

        <NotificationPreferencesForm />
      </div>
    </section>
  );
}

export default NotificationPreferencesScreen;
